import {showHazmatModal} from '../Modals/HazmatModal.js'
import {
  canAddHazmatItemSelector,
  canHaveHazMatItemsSelector,
  hazmatItemsSelector,
  isLabelPropertyEnabledSelector,
} from '../../../data/labelInfos/index.js'
import {useSelector} from '../../../store.js'
import {showRemoveHazmatItemModal} from '../Modals/RemoveHazmatItemModal.js'
import EnableLabelProperty, {
  PickLabelProperty,
} from '../Fields/EnableLabelProperty.js'
import useLabelProperty, {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from '../Fields/useLabelProperty.js'
import {
  PITNEY,
  PITNEY_MERCHANT,
  UPS,
  USPS_SHIP,
} from '../../../common/constants/ShipperNames.js'
import className from '../../../common/className.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

function labelPropertiesFunc(shipperType) {
  return shipperType === UPS
    ? ['packages[0].hazmat_items']
    : [PITNEY, PITNEY_MERCHANT].includes(shipperType)
      ? [`${shipperType}__hazmat_type`, 'hazmat_electronics']
      : shipperType === USPS_SHIP
        ? [`${shipperType}__hazmat_type`]
        : []
}
const VALID_SHIPPER_TYPES = [UPS, PITNEY, PITNEY_MERCHANT, USPS_SHIP]

export default function AttachHazmatInfo() {
  const {labelInfoID, shipperType, isLabelEnableMode, isSummary, isPickMode} =
    useLabelConfigContext()
  const propertySpecs = AttachHazmatInfo.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const hazmatItems = useSelector((state) =>
    hazmatItemsSelector(state, {labelInfoID, packageIndex: 0, shipperType}),
  )
  const canAddHazmatItem = useSelector((state) =>
    canAddHazmatItemSelector(state, {
      labelInfoID,
      packageIndex: 0,
      shipperType,
    }),
  )

  const canHaveHazMatItems = useSelector((state) =>
    canHaveHazMatItemsSelector(state, {labelInfoID, shipperType}),
  )

  const isLabelPropertyEnabled = useSelector((state) =>
    isLabelPropertyEnabledSelector(state, {
      labelInfoID,
      labelProperty,
    }),
  )

  const disabled = isLabelEnableMode && !isLabelPropertyEnabled

  useLabelProperty({
    labelProperty,
    propertySpecs,
  })

  if (!VALID_SHIPPER_TYPES.includes(shipperType)) {
    return null
  }

  if (!canHaveHazMatItems) {
    return null
  }

  const label = 'Hazardous Materials Declarations'

  if (isSummary) {
    return label
  }

  if (isPickMode) {
    return <PickLabelProperty label={label} labelProperty={labelProperty} />
  }

  return (
    <li
      className={className`list__item--shipping-options list__item--hazmat ${{
        'divider--top divider--bottom': !isLabelEnableMode,
        'property-disabled': disabled,
      }}`}
    >
      <div className="wrap--edit-preset-form-input">
        <div className="fs-00 lh-sm margin-bottom-7 label--config__txt">
          <strong>{label}</strong>
        </div>
        <ul className="list list--square margin-bottom-0 label--config__txt">
          {hazmatItems.map((hazmatItem, index) => (
            <li className="list__item lh-sm margin-bottom-5" key={index}>
              <span className="fs-n0 margin-right-7 ">
                {hazmatItem.type_display ? (
                  hazmatItem.type_display
                ) : hazmatItem.electronics ? (
                  'Contains Electronics'
                ) : (
                  <>
                    {hazmatItem.proper_shipping_name || 'Unknown Hazmat Item'} (
                    {hazmatItem.quantity || 0})
                  </>
                )}
              </span>
              <button
                className="btn btn--link inline-block fs-n1 v-align-base divider--right sm"
                type="button"
                onClick={() =>
                  showHazmatModal(labelInfoID, shipperType, 0, index)
                }
                disabled={disabled}
              >
                Edit
              </button>
              <button
                className="btn btn--link no-underline inline-block fs-n1 v-align-base"
                type="button"
                onClick={() =>
                  showRemoveHazmatItemModal(labelInfoID, shipperType, 0, index)
                }
                disabled={disabled}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
        {canAddHazmatItem && (
          <div>
            <button
              className="btn btn--link inline-block fs-n1 v-align-base"
              type="button"
              onClick={() => showHazmatModal(labelInfoID, shipperType, 0)}
              disabled={disabled}
            >
              Add a declaration
            </button>
          </div>
        )}
      </div>
      <EnableLabelProperty labelProperty={labelProperty} />
    </li>
  )
}

AttachHazmatInfo.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
